import React, { Component } from "react";
import { Tabs, Alert, Input, Button, message } from "antd";
import { connect } from 'dva'
import img from "../../../../assets/contacts/phone_info.png";
import styles from "./index.less";
import { getUserInfo } from '@/services/fetchUserInfo'

const { TabPane } = Tabs;

@connect(({ baseTool }) => ({
  ...baseTool,
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: '',
      orgId: '',
    };
  }

  componentDidMount() {
    const me = this;
    getUserInfo((org) => {
      if (!org) {
        return !1;
      }
      const { orgId } = org && org.user
      me.setState({
        orgId,
      })
    });

  }

  handleCheck = () => {
    const { mobile, orgId } = this.state;
    //   const {dispatch} = this.props
    if (!/^1[3456789]\d{9}$/.test(mobile)) {
      message.error("手机号码格式有误，请重填");
      return !1;
    }

    if (!orgId) {
      message.error("orgId不能为空");
      return !1;
    }

    this.props.dispatch({
      type: 'baseTool/fetchDeleteParent',
      params: {
        orgId,
        mobile
      },
      callback: () => {
        message.success("修复完成，请家长重新扫码关注");
      }
    })
  };

  handleInput = e => {
    this.setState({
      mobile: e.target.value
    });
  };

  render() {
    return (
      <div className={styles['tool-cintainer']}>
        <Tabs defaultActiveKey="1" onChange={this.handleTabChange}>
          <TabPane tab="手机号码被占用" key="1">
            <Alert
              message="使用说明"
              description="部分家长在使用微信扫码关注，会如下图提示“手机号被占用”，原因是微信手机号绑定错误，需要调用接口进行修复，修复完成后，请家长重新扫码关注即可正常使用。"
            />
            <div className="content">
              <img className="img" src={img} alt="" />
              <div className="check">
                <Input onChange={this.handleInput} placeholder="请输入被占用的手机号" />
                <Button style={{ marginLeft: 10 }} onClick={this.handleCheck}>
                  立即修复
                </Button>
                <p style={{marginTop:20}}>
                  注：请谨慎输入要修复手机号，为了确保用户账号的安全，每次操作均会记录。
                </p>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default index;
